import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactMatrixComponent } from './contact-matrix.component';
import { ContactMatrixCountPipe, ContactTotalPipe } from './pipes';
import { DataTableModule } from '../ui-components';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    declarations: [ContactMatrixComponent, ContactMatrixCountPipe, ContactTotalPipe],
    exports: [ContactMatrixComponent],
    imports: [
        DisableAutocompleteDirectiveModule,
        DataTableModule,
        CommonModule
    ]
})
export class ContactMatrixModule {}
